import { Box, CircularProgress } from '@mui/material';

export const ViewLoader = () => (
  <Box mt={4} display="flex" justifyContent="center" data-testid="view-loader">
    <CircularProgress color="secondary" />
  </Box>
);
